<template>
    <div>

        <v-row class="d-flex justify-space-between py-0">

            <v-col class="map">
                <div id="text-map">{{elTema.nivel}} <span class="titulo">Nivel:</span></div>
                <div id="text-map">{{elTema.grado}} <span class="titulo">Grado:</span></div>
                <div id="text-map">{{elTema.area}} <span class="titulo">Area:</span></div>
                <div id="text-map">{{elTema.curso}} <span class="titulo">Curso:</span></div>
            </v-col>


            <v-col cols="auto" class="py-0">
                <v-btn class="btn_block_style2 mr-2" dark  @click="aggClase">Crear Tema</v-btn>
                <v-btn class="btn_style3" dark  @click="atras">VOLVER</v-btn>
            </v-col>
        </v-row>


        <v-row>
            <v-col>
                <div class="tema"><span> UNIDAD: {{elTema.nombreTema}}</span></div>
            </v-col>
        </v-row>


      
                
        <v-card>
            <v-data-table :headers="headers" :items="contenido" class="elevation-1 black--text" fixed-header>
                               
                <template v-slot:[`item.fecha`]="{ item }">
                    {{item. fecha_ingreso | fecha}}
                </template>

                <template v-slot:[`item.edit`] ="{ item }">
                    <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="btn_editar px-0 mx-0" fab x-small @click="editClase(item)">
                                <v-icon>fa-pencil-alt</v-icon>
                            </v-btn> 
                        </template>
                        <span>EDITAR NOMBRE DEL TEMA</span>
                    </v-tooltip>
                </template>


                <template v-slot:[`item.view`] ="{ item }">
                    <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="btn_ver px-0 mx-0" fab x-small @click="visorDiapositivas(item) ;visclas=false;">
                                <v-icon>fa-eye</v-icon>
                            </v-btn>
                        </template>
                        <span>VER DIAPOSITIVAS</span>
                    </v-tooltip>
                </template>

                                
                

            

                <template v-slot:[`item.view_diapo`] ="{ item }">
                    <v-btn class="mx-2 pl-1" fab dark x-small color="green" title="crear diapositiva" @click="VerContenidos(item) " ><v-icon small >fas fa-file-signature</v-icon></v-btn>
                </template>

                <!-- cuaderno de trabajo -->
                <template v-slot:[`item.cuaderno`]="{ item }">  
                    
                    <v-btn v-if="item.cuaderno_trabajo==='' || item.cuaderno_trabajo===null" class="mx-2 btn_otro" fab dark x-small title="cuaderno de actividades"
                             @click="addCuaderno(item)">
                        <v-icon>fa-file-upload</v-icon>
                    </v-btn>
                    
                    
                    <v-menu v-else absolute offset-y style="width:380px">
                        <template v-slot:activator="{ on }">

                            <v-row justify="space-around" v-on="on">
                                <v-btn class="mx-2" fab dark x-small color="primary">
                                    <v-icon small >fas fa-book-reader</v-icon>
                                </v-btn>                      
                            </v-row>
                        </template>
                        
                        <v-card class="card-icon">
                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <div class="template-button">
                                        <p class="mr-2">Eliminar</p>
                                        <v-btn v-on="on" class="error ml-5 mb-2" fab x-small @click="eventDeleteCuaderno(item)"  >
                                            <v-icon>fas fa-trash</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <span style="text-transform:uppercase;">ELIMINAR </span>
                            </v-tooltip>

                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <div class="template-button">
                                        <p>Descargar</p>
                                        <!--
                                        <v-btn v-on="on" class="primary  ml-5 mb-2 " fab x-small dark >
                                            <a :href="ruta_api+'/archivo/obtenerarchivo/'+item.cuaderno_trabajo" target="_parent"> <v-icon color="white">fas fa-file-word</v-icon></a>
                                        </v-btn>
                                        -->
                                       <v-btn v-on="on" class="primary  ml-5 mb-2 " fab x-small dark 
                                          @click="download(ruta_api+'archivo/obtenerarchivo/'+item.cuaderno_trabajo)">
                                           <v-icon color="white">fas fa-file-word</v-icon>
                                        </v-btn>
                                   
                                    </div>
                                </template>
                                <span>DESCARGAR</span>
                            </v-tooltip>
                        </v-card>
                    </v-menu>
                </template>

                <template v-slot:[`item.session`] ="{ item }">
                    <!--  BOTONES DE ELIMINACION Y DESCARGA DE ARCHIVOS - -->
                        <!-- <v-btn class="mx-2 pl-1" fab dark x-small color="dark" title="sesion de aprendizaje" @click="aggSessionAprendizaje(item)" v-if="item.sesion==='' || item.sesion===null"><v-icon small >fas fa-cloud-upload-alt</v-icon></v-btn> -->
                        <v-menu absolute offset-y style="width:380px">
                            <template v-slot:activator="{ on }">
                                <v-row justify="space-around" v-on="on">
                                        <v-btn class="mx-2 pl-1" fab dark x-small color="teal" @click="getSesionAprendizaje(item.id_tema)"><v-icon small >fas fa-file</v-icon></v-btn>
                                        <!-- <v-icon color="info">fas fa-file</v-icon>-->
                                </v-row>
                            </template>
                            <v-card class="card-icon" v-if="!loadingSesionAprendizaje">
                                <v-tooltip bottom color="#1b1b1b"  v-if="!sesionAprendizaje.id">
                                    <template v-slot:activator="{ on }">
                                        <div  class="template-button">
                                            <p class="mr-2">Crear</p>
                                            <v-btn v-on="on" class="btn_agregar  ml-2 mb-2" fab x-small  @click="aggSessionAprendizaje(item)"  >
                                                <v-icon>fas fa-plus-circle</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                        <span style="text-transform:uppercase;">CREAR </span>
                                </v-tooltip>
                                <v-tooltip bottom color="#1b1b1b" v-else>
                                    <template v-slot:activator="{ on }">
                                        <div  class="template-button">
                                            <p>Editar</p>
                                            <!--
                                            <v-btn  v-on="on" class="primary  ml-5 mb-2 " fab x-small dark >
                                                <a :href="ruta_api+item.sesion"  target="_blank"> <v-icon color="white">fas fa-file-word</v-icon></a>
                                            </v-btn>
                                            -->
                                            <!-- <v-btn  v-on="on" class="primary  ml-5 mb-2 " fab x-small dark 
                                                @click="download(ruta_api+item.sesion)">
                                                <v-icon color="white">fas fa-file-word</v-icon>
                                            </v-btn> -->
                                            <v-btn class="ml-2 mb-2" fab dark x-small color="warning" title="Editar" @click="aggSessionAprendizaje(item)">
                                                <v-icon small >fa-edit</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>EDITAR</span>
                                </v-tooltip>
                            </v-card>
                        </v-menu>

                        <!-- -------------------------------------------- -->
                    </template>
                                                
                    <!--
                    <v-btn class="mx-2 pl-1" fab dark x-small color="dark" title="sesion de aprendizaje" @click="aggSessionAprendizaje(item)" v-if="!item.sesion"><v-icon small >fas fa-cloud-upload-alt</v-icon></v-btn>
                        <a :href="ruta_api+item.sesion"  target="_blank"  v-else ><v-btn class="mx-2 pl-1" fab dark x-small color="primary" title="sesion de aprendizaje"><v-icon small >fas fa-file-alt</v-icon></v-btn></a>
                    </template>-->
                   
                    <template v-slot:[`item.delete`] ="{ item }">
                        <v-tooltip bottom color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="btn_eliminar px-0 mx-0" fab x-small @click="showConfirmDeleteClase(item)">
                                    <v-icon>fa-trash-alt</v-icon>
                                </v-btn>
                            </template>
                            <span>BORRAR TEMA</span>
                        </v-tooltip>
                    </template>
            </v-data-table>
        </v-card>


       
           
         
    

        <!----- modales ---->
        <v-dialog v-model="dialog2" max-width="500px">
            <v-card>
                <v-card-title class="primary">
                           <span class="headline texto">{{ formTitle2 }}</span>
                </v-card-title>
                    <v-container>

                        <v-alert type="error" v-if="errorClase" class="mt-2">{{menssageError}}</v-alert>
                        <v-row>
                            <v-col cols="12" sm="6" md="12"  v-show="false">
                                <v-autocomplete v-model="formClase.id_tema" :items="vis_tema" label="Tema:"
                                    item-text="nombre_tema" item-value="id"
                                    persistent-hint single-line>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <v-chip class="primary">Unidad: {{elTema.nombreTema}}</v-chip>
                            </v-col>

                            <v-col cols="12" sm="6" md="12">
                                <v-text-field v-model="formClase.nombre_clase" label="Nombre del Tema" @keyup="validacionCampos();"></v-text-field>
                            </v-col>


                            <v-col cols="12" sm="6" md="12">
                                <v-text-field type="number" label="Orden" min="0" v-model="formClase.orden_clase" @keyup="validacionCampos()"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
           
             
           

                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="error"  @click="close2">Cancelar</v-btn>
                    <v-btn color="warning"  v-if="editar2" :disabled="this.guardando" @click="updateClase()">Editar</v-btn>
                    <v-btn color="primary"  v-if="agregar2" :disabled="this.guardando" @click="addClase">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <!--modal para agregar sesion de aprendizaje -->
        <v-dialog v-model="modal_sesion"  persistent scrollable max-width="90%">>
            <sesionAprendizaje @close="cerrarModal" :datosSesionAprendizaje="sesionAprendizaje" :datosTema="datosSesion"></sesionAprendizaje>
        </v-dialog>


        <!-- modal cargar cuaderno de trabajo -->
        <v-dialog v-model="modal_cuaderno" persistent scrollable max-width="30%">
            <v-card>
                <v-card-title class="btn_otro">
                    <v-row class="d-flex justify-space-between py-0">
                        Agregar cuaderno de actividades
                        <v-btn fab dark x-small class="btn_style3"  @click="closeCuaderno"><v-icon dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>

                    <v-col cols="12" class="text-center">
                        <input type="file"  @change="cargarPrevia" accept=".docx,.pdf" ref="myFileInput">
                    </v-col>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer> 
                    <v-btn :disabled="!existeArchivo" @click="submitFileCuaderno" class="primary">Subir</v-btn>
                </v-card-actions> 
            </v-card>
        </v-dialog>


         
        <span v-if="test">
            <!--
            Contenido <code>{{contenido}}</code>
            Tema <code>{{elTema}}</code>
            -->
            Cuaderno Trabajo  <code>{{arrayCuaderno}}</code>
        </span>

        <!-- Visor Nuevo del Gestor de Contenido 
            Actualizado por el Ing Wuilmer 2020-01-22
        -->
        <component :is="compName" :estadoModal="estadoModalConfig" @close="estadoModalConfig = false"
                   :parametros="parametroConfigVisor">
        </component>

        <!-- confirm para elimianr clase -->
        <Confirm
            title="¿Estás seguro que desea eliminar este registro?"
            :active="confirmDeleteClase"
            @aceptar="deleteClass"
            @cancelar="cerrarConfirmDeleteClase"
        />

        <!-- confirm para eliminar adjunto(sesion aprendizaje) -->
        <Confirm
            title="¿Estás seguro que desea eliminar este registro?"
            :active="confirmDeleteAdjunto"
            @aceptar="deleteAdjunto"
            @cancelar="cerrarConfirmDeleteAdjunto"
        />        



        <!-- <Confirm
            title="¿Estás seguro que desea eliminar este registro?"
            :active="confirmDeleteSesion"
            @aceptar="deleteSesion"
            @cancelar="cerrarConfirmDeleteSesion"
        /> -->

        <Confirm
            title="¿Estás seguro que desea eliminar este registro?"
            :active="confirmDeleteCuaderno"
            @aceptar="deleteCuaderno"
            @cancelar="cerrarConfirmDeleteCuaderno"
        />

                

    </div>
</template>



<script>
    import axios,{API_URL} from '@/helpers/axios'
    //import {mapState, mapActions, mapGetters, mapMutations } from 'vuex';
    import {mapMutations } from 'vuex';
    import visorContenido from './visorGestorContenido';
    import Confirm from "@/components/confirm"
    import sesionAprendizaje from "@/views/Manager/CreadorContenido/componentes/sesionAprendizaje/sesionAprendizaje.vue";

    export default {
        name:'clasesComponent',
        props:['contenido','elTema'],

        components:{
            visorContenido,
            Confirm,
            sesionAprendizaje
        },

        data(){
            return{
                compName:"",
                estadoModalConfig: false,
                parametroConfigVisor : [],
                test:false,
                guardando:false,

                itemDelete: '',

                confirmDeleteClase: false,                                
                confirmDeleteAdjunto: false,                
                confirmDeleteSesion: false,    
                confirmDeleteCuaderno : false,

                dialog2:false,
                editedIndex2:-1,
                nombre_tema_actual:'',
                agregar2:false,
                editar2:false, 
                tipoAgg:null,
                vis_tema:[],
                errorClase:false,
                menssageError:'',
                tuid_clase:null,
                select_tema:false,
                ruta_api: API_URL,

                headers: [
                    /* { text: 'TEMA', value: 'nombre_tema', class:'secondary black--text' }, */
                    { text: 'TEMAS', value: 'nombre_clase', class:'secondary black--text'},
                    { text: 'FECHA', value: 'fecha', class:'secondary black--text' },
                    { text: 'ORDEN', value: 'orden_clase', class:'secondary black--text' },
                    // { text: 'Area', value: 'desc_area'},

                    {text: 'EDITAR NOMBRE DEL TEMA', value: 'edit', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'100'},
                    {text: 'VER DIAPOSITIVAS', value: 'view', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'100'},
                    {text: 'CREAR DIAPOSITIVAS', value: 'view_diapo', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'100'},
                    {text: 'CUADERNO DE ACTIVIDADES', value:'cuaderno', sortable: false, align: 'center' ,  class:'secondary black--text px-0 mx-0', width:'100'},
                    {text: 'SESIÓN DE APRENDIZAJE', value: 'session', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'100'},
                    {text: 'BORRAR', value: 'delete', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'}
                ],

                formClase: {
                    id_tema:null,
                    nombre_clase: '',
                    sesion_aprendizaje: '',
                    ubicacion_repositorio: '',
                    orden_clase: null,
                    id_usuario: sessionStorage.id,
                },

                defaultaddclase: {
                    id_tema:null,
                    nombre_clase: '',
                    sesion_aprendizaje: '',
                    ubicacion_repositorio: '',
                    orden_clase:null,
                    id_usuario:sessionStorage.id,
                },

                //////////////
                modal_sesion:false,
                datosSesion:{},
                mensaje_sesion:false,
                
                nombreArchivo :'',
                extensionFile:'archivo/obtenerArchivo/',
                existeArchivo:false,
                arrayCuaderno:{},
                modal_cuaderno:false,

                sesionAprendizaje: {id: null},
                loadingSesionAprendizaje: false
            }
        },
        mounted(){
            console.log("Contenido: ", this.contenido);
        },

        computed:{
            formTitle2 () {
                return this.editedIndex2 === -1 ? 'Agregar Tema' : 'Editar Tema'
            },
        },


        filters: {
            fecha: function(string) {
                var cadena1 = string.slice(0, -14)
                var cadena2 = cadena1.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');
                return cadena2;
            }
        },


        methods:{
            ...mapMutations('mensajeSis', ['setEnviarMens']),

            // funciones emit 
            atras(){
                this.$emit('volverAtras');
            },

            actualizar(id){
                this.$emit('actualizarClass',id);
            },

            VerContenidos(item){
                this.$emit('cargar-contenido',item);
            },

            visorDiapositivas(item){
                // visor            
                this.compName  = "visorContenido"
                this.estadoModalConfig = true
                this.parametroConfigVisor = item
            },

            mensaje(tipo,message){
                this.$emit('mostrar-mensaje',tipo,message);
            },
            //////////////////////////////////////////////////////


            /////////// apertura de modal para agregar clase/////
            async aggClase(){
                await this.vista_tema();

                this.tipoAgg = 2
                this.editedIndex2 = -1
                this.formClase.id_tema = this.elTema.id_tema
                this.formClase.orden_clase = this.contenido.length+1;
                this.dialog2 = true  
                this.select_tema = true
                this.agregar2 = true
                this.editar2 = false
            },
        //////////////////////////////////////////////////
        /////////// cargar modal con datos para editar///
            editClase(item){
                    this.tuid_clase = item.id_clase
                    this.editedIndex2 = this.contenido.indexOf(item)
                    this.formClase.id_tema = item.id_tema
                    this.formClase.nombre_clase = item.nombre_clase
                    this.formClase.sesion_aprendizaje = item.sesion
                    this.formClase.ubicacion_repositorio = item.ubicacion
                    this.formClase.orden_clase = item.orden_clase
                    this.nombre_tema_actual = this.elTema.nombreTema
                    this.dialog2 = true             
                    this.select_tema = false
                    this.editar2 = true
                    this.agregar2 = false
            },
        ////////////////////////////////////////////////////
        //////////   CERRAR  MODAL DE CLASES //////////////
            close2() {
                    this.agregar2 = true
                    this.editar2 = false
                    this.dialog2 = false
                    this.formClase = Object.assign({}, this.defaultaddclase)                
                    this.errorClase = false
            },
        //////////////////////////////////////////////////
        ////////// CONSULTA DE TEMAS GENERALES ///////////
            async vista_tema(){
                try{
                    let response = await axios.get("/manager/tema/");
                    this.vis_tema = response.data
                }catch(error){
                    console.log(error);
                }
            },
        /////////////////////////////////////////////////
        //////////// VALIDACION DE CAMPOS //////////////
            validacionCampos(){
                    if(this.formClase.nombre_clase != '' || this.formClase.orden_clase != null){
                        this.error_validacion =  false
                    }
            },
        ///////////////////////////////////////////////
        //////////  añadir una nueva clase ///////////
            async  addClase(){
                //console.log("--------------- creating..................")
                if(this.formClase.nombre_clase === '' || this.formClase.orden_clase === null){
                        this.mostrarError('Existe un campo vacio porfavor verifique!!!');
                }else{
                    //this.agregar2 = false
                    let params = this.formClase
                    this.guardando = true
                    try{
                        await axios.post("/manager/clase/",params)
                        .then(({data})=>{
                            //console.log("data:",data)
                            this.mensaje(data.messageT,data.message);
                            if(data.messageT==this.$states.success){
                                this.actualizar(this.elTema.id_tema);
                                this.dialog2 = false
                                this.formClase = Object.assign({}, this.defaultaddclase)
                                this.editedIndex2 = -1
                                this.guardando =false;
                            }
                        })
                        //this.agregar2 = true
                    }catch(error){
                        console.log(error);
                        this.mostrarError('Ocurrio un error , intente nuevamente!!!');
                        this.guardando =false
                        //this.agregar2 = true
                    }
                }
            },
        //////////////////////////////////////////////////////////////////////
        //////////////////   ACTUALIZAR CLASE  //////////////////////////////
            async updateClase(){
                try{
                    this.guardando = true
                    await axios.put("/manager/clase/"+this.tuid_clase,this.formClase)
                    .then(({data})=>{
                        if(data.messageT==this.$states.success){
                            this.guardando = false
                            this.actualizar(this.elTema.id_tema);
                            this.close2();
                        }
                        this.mensaje(data.messageT,data.message);
                    })
                    //console.log(response);
                }catch(error){
                    console.log(error);
                }
            },
        ////////////////////////////////////////////////////////////////
        //*****  borral clase  */
        async deleteClass(){
        try{
                const {data} = await axios.put('/manager/clase/dt/inac/'+this.itemDelete+"");
                console.log("data:",data)
                this.actualizar(this.elTema.id_tema);
                this.mensaje(data.messageT,data.message);
                this.cerrarConfirmDeleteClase()
            }catch(error){
                this.mensaje("E","Ha ocurrido un error , por favor intente nuevamente");
                this.cerrarConfirmDeleteClase()
            }
        },
        showConfirmDeleteClase(item){
            console.log("ELIMINANDO TEMA", item)
            this.confirmDeleteClase = true
            this.itemDelete = item.id_clase
        },
        cerrarConfirmDeleteClase(){
            this.confirmDeleteClase = false
            this.itemDelete = ''
            
        },
        ///////////////////   MOSTRAR MENSAJE DE ERROR  ///////////////
        mostrarError(mensaje){
            this.errorClase = true
            this.menssageError = mensaje
            setTimeout( () => {
                this.errorClase = false
            },3000)
        },
        /////////////////////////////////////////////////////////////
        /////////////  APERTURA MODAL SESION DE APRENDIZAJE ////////
        aggSessionAprendizaje(item){
            this.datosSesion = item;
            this.modal_sesion = true;
        },

        async getSesionAprendizaje(id_tema){
            this.loadingSesionAprendizaje = true;
            this.sesionAprendizaje = {id: null};
            try{
                let resp = await axios.get(`/manager/sesionAprendizaje/tema/${id_tema}/`);
                if(resp.data)
                    this.sesionAprendizaje = resp.data
            }  catch(error){
                console.log(error);
            }
            this.loadingSesionAprendizaje = false;
        },
        
        //////////////////////////////////////////////////////////
            cargarPrevia(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                return;
                this.nombreArchivo =  files[0]
                if(this.nombreArchivo != ''){
                    this.existeArchivo = true
                    
                }
                console.log(this.nombreArchivo)
            },
        ///////////////////////////////////////////////////////////
            async submitFile(){
                let formData = new FormData();
                formData.append('subirArchivo', this.nombreArchivo);
                formData.append('id_nivel', this.datosSesion.id_nivel_grado);
                formData.append('id_grado', this.datosSesion.id_grado_tema);
                formData.append('id_area',  this.datosSesion.id_area);
                formData.append('id_curso', this.datosSesion.id_curso);
                formData.append('id_tema',  this.datosSesion.id_tema);
                formData.append('id_clase', this.datosSesion.id_clase);

                try{
                    const {data} = await  axios.post( '/archivo/sesionCK1Add',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                    //  console.log("data:",data)
                    this.addSessionCk1(data.payload);
                    this.mensaje_sesion = true
                    this.$refs.myFileInput.value = '';
                }catch(error){
                    console.log(error)
                }
            },
        //////////////////////////////////////////////////////////////////
            /*********funcion para registrar datos en base de datos de la sesion ****/
        async  addSessionCk1(response){
            console.log("response:",response)
            let id = this.datosSesion.id_clase
            let params = {
                "id_usuario":sessionStorage.id,
                "sesion_aprendizaje":`${this.extensionFile}${response.rutaDestino}${response.nombreArchivo}`
            }
            console.log('parametros para sesion====>>>'+JSON.stringify(params));
            try{
            await axios.put("/manager/clase/sa/"+id,params);
            this.actualizar(this.elTema.id_tema);
                setTimeout(() => {
                    this.cerrarModal();
                }, 300)
            }catch(error){
                console.log(error);
            }
        },
        
        cerrarModal(){
            this.modal_sesion = false
            this.mensaje_sesion = false
            this.existeArchivo = false
            this.nombreArchivo = "" 
            this.arrayCuaderno = {}
            if(this.$refs.myFileInput)
                this.$refs.myFileInput.value = '';
        },



        /////////////////////////////////////////////////////////////////////
        //*****************funcion para eliminar sesion  de base de datos */
        showConfirmDeleteAdjunto(item){
            this.confirmDeleteAdjunto = true
            this.itemDelete = item
        },
        cerrarConfirmDeleteAdjunto(){
            this.confirmDeleteAdjunto = false
            this.itemDelete = ''   

        },





        async  deleteAdjunto(){
            try{
                let item = this.itemDelete
                let params = {
                    "id_tema":item.id_clase_tema,
                    "id_usuario":sessionStorage.id,
                    "estado_clase":item.estado_clase,
                    "nombre_clase":item.nombre_clase,
                    "sesion_aprendizaje":null,
                    "ubicacion_repositorio":item.ubicacion,
                    "orden_clase":item.orden_clase
                }
                const {data} = await axios.put("/manager/clase/"+item.id_clase,params);
                //console.log("response:",resp)
                if(data.messageT === this.$states.success){
                    await this.deleteArchivo(item);
                    //await this.actualizarSesion(item.id_clase_tema);
                }
                this.setEnviarMens({tipo:data.messageT, mensaje: data.message, tiempo:null})
            }catch(error){
                console.log(error);
            }
        }, 
        ////////////////////////////////////////////////////////////////////
        /**********funcion call para borrado de archivo en los documentos */
        async deleteArchivo(item){
            let p  = item.sesion.replace("/archivo/obtenerArchivo/", "");
            let params =  {
                "ruta":p
            }
            try{   

                    await axios.post("/archivo/delete/",params);
                    await this.actualizar(this.elTema.id_tema);
                    this.cerrarConfirmDeleteAdjunto()
                //this.setEnviarMens({tipo:response.data.messageT, mensaje: response.data.message, tiempo:null})

            }catch(error){
                // this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                console.log(error);
            }
        },

        
            // CUADERNO DE TRABAJO  //

            ////////////////// cuaderno de trabajo /////////////////////
            addCuaderno(item){
                console.log(item)
                this.modal_cuaderno         = true
                this.arrayCuaderno = item

                // this.arrayCuaderno.id       = item.id_clase
                // this.arrayCuaderno.id_nivel = item.id_nivel
                // this.arrayCuaderno.id_grado = item.id_grado
                // this.arrayCuaderno.id_curso = item.id_curso
                // this.arrayCuaderno.id_tema  = item.id_tema
                // this.arrayCuaderno.id_area  = item.id_area
                // this.arrayCuaderno.id_clase  = item.id_clase
                
            },

            async submitFileCuaderno(){

                    let formData = new FormData();
                    formData.append('subirArchivo',  this.nombreArchivo);
                    formData.append('id_nivel',        this.arrayCuaderno.id_nivel_grado);
                    formData.append('id_grado',      this.arrayCuaderno.id_grado_tema);
                    formData.append('id_curso',      this.arrayCuaderno.id_curso);                    
                    formData.append('id_area',      this.arrayCuaderno.id_area);
                    formData.append('id_tema',      this.arrayCuaderno.id_tema);
                    formData.append('id_clase',      this.arrayCuaderno.id_clase);
                    
                try{
                    let response = await  axios.post('/archivo/cuadernoTrabCK1Add',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                        )
                this.addCuadernoTrabajo(response.data);
                this.$refs.myFileInput.value = '';
                //this.mensaje_sesion = true
                console.log(response.data)
                }catch(error){
                    console.log(error)
                }
            },
            closeCuaderno(){
                this.modal_cuaderno = false
                this.arrayCuaderno = {}
                this.nombreArchivo = ""
                this.existeArchivo = false
                this.$refs.myFileInput.value = '';
            },
            
            ///////////////////////////////////////////////////////////////////////
            /////////////funcion para agregar cuaderno de trabajo a BD/////////////
            async addCuadernoTrabajo(response){
                console.log(response);

                // let id = this.datosSesion.id_clase
                let paramCuaderno = {
                    id_usuario:sessionStorage.id,
                    cuaderno_trabajo:`${response.uri}${response.nombreArchivo}`
                }
                try{
                    await axios.put(`/manager/clase/cuadernoTrabajo/${this.arrayCuaderno.id_clase}`,paramCuaderno)
                    this.setEnviarMens({tipo:"S", mensaje: "¡Tu cuaderno de trabajo fue cargado correctamente!", tiempo:null})
                    
                     this.actualizar(this.elTema.id_tema);
                    setTimeout(() => {
                        this.closeCuaderno();
                    }, 1000)
                }catch(error){
                    console.log(error)
                }
            },


            eventDeleteCuaderno(item){

                this.confirmDeleteCuaderno = true
                this.itemDelete            = item
                

            },
            ///////////////////////////////////////////////////////////////
            async deleteCuaderno(){
              
                let paramCuaderno = {
                    id_usuario:sessionStorage.id,
                    cuaderno_trabajo:null
                }
            
                let params =  {
                    "ruta":this.itemDelete.cuaderno_trabajo
                }

                try{
                    let res = await axios.put(`/manager/clase/cuadernoTrabajo/${this.itemDelete.id_clase}`,paramCuaderno);
                    console.log(res);
                    if(res.data.messageT === 'S'){

                        let response = await axios.post("/archivo/delete/",params);
                        this.setEnviarMens({tipo:response.data.messageT, mensaje: response.data.message, tiempo:null})
                        this.actualizar(this.elTema.id_tema);
                        this.confirmDeleteCuaderno = false
                    }    
                }catch(error){
                    console.log(error)
                }
            },

                 
            cerrarConfirmDeleteCuaderno(){
                this.confirmDeleteCuaderno = false
                this.itemDelete = ''
                this.existeArchivo = false
            },



            async download(url) {    
                const _url = url.split("/")  
                 try{
                    let response = await axios.get(url)

                    if(response){
                        this.$Files.dowload({ url:url, filename:_url[_url.length-1]})
                    }
        
                }catch (error) {

                    if (error) {
                        let resp = error.response.data
                        console.log(`***  RESPONSE MENSAJE : ${resp.message}` );  
                        this.setEnviarMens({tipo: resp.messageT, mensaje: ` ${resp.message}`, tiempo:null})   
                    }               
                }
                
            },

        },

    }
</script>



<style  scoped>
    .titulo-text{
        color: #045FB4;
        font-size: 23px;
        height: 50px;
        background: #fff;
        border-left: 5px solid #045FB4;
        padding-left: 11px;
        padding-top: 7px;
        box-shadow: 5px 5px 5px #D8D8D8;
    }


    .map{
        width: 600px;
    }


    .text{
        color: #295ED1;
    }


    .map #text-map{
        font-size: 22px;
        border-bottom: 2px solid;
        margin-right: 15px;
        padding-left: 12px;
        position: relative;
        color: #295ED1;
        display: inline-block;
        width: 22%;
        margin-top: 0px;
    }


    @media(max-width: 425px){
        .map #text-map{
            width: 100%;
            display: block;
            margin-top: 12px;
        }
    }


    .map #text-map .titulo{
        position: absolute;
        font-size: 12px;
        border: none;
        color: #fff;
        top: -12px;
        left: -3px;
        width: 50px;
        height: 17px;
        background: #295ED1;
        padding-left: 7px;
        border-radius: 4px;
    }


    .texto{
        color: #fff;
    }


    .tema{
        width: auto;
        height: 46px;
        background: #ffff;
        border-left: 6px solid #295ED1;
        box-shadow: 4px 3px 5px #888888;
        padding-left: 14px;
        padding-top: 9px;
    }


    .tema span{
        text-transform: uppercase;
        font-size: 19px;
        width: 550px;
        color: #295ED1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }


    @media(max-width:425px){
        .tema span{
            font-size: 15px;
            width: 250px;
        }
    }


    .template-button{
        position: relative;
        display: inline-block;
        padding:4px ;
    }
</style>